import React from "react";
import {startCase} from "lodash";
import {Badge} from "reactstrap";
import "./statusBadge.scss";

export const StatusBadge = ({status}) => {
  const label = startCase(status);
  if (!label) return "-";

  return (
    <Badge color="" className={`status-badge status-badge--${status}`}>
      {label}
    </Badge>
  );
};
